const initVideoPlayer = () => {
  const allPlayButtons = document.querySelectorAll('.lbc-media-container__play-button');

  allPlayButtons.forEach(playButton => {
    playButton.addEventListener('click', () => {
      const video = playButton.closest(".lbc-media-container").querySelector('.lbc-media-container__media');

      if (video.paused) {
        video.play();
      } else {
        video.pause();
      }

      video.addEventListener('ended', () => {
        playButton.classList.remove('hide');
        video.controls = false;
      });

      video.addEventListener('play', () => {
        playButton.classList.add('hide');
        video.controls = true;
      });

      video.addEventListener('pause', () => {
        playButton.classList.remove('hide');
        video.controls = false;
      });
    });
  });
};

export { initVideoPlayer };